import { Box, CircularProgress, SelectChangeEvent } from "@mui/material";
import CustomSelect from "../../../../common/components/CustomSelect";
import { Tender } from "../../../tender_page/tender.module";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../common/hooks/default";
import { TenderStatus } from "../../pricingListSlice";
import { PrimaryButton } from "../../../../common/components/CustomButton";
import { updateTenderStatus } from "../../../tender_page/tender.thunk";
import { useSelector } from "react-redux";
import {
	selectLoader,
	selectStatusIsDirty,
} from "../../../tender_page/tender.selector";
import { setStatusIsDiry } from "../../../tender_page/tenderSlice";

interface TenderStatusCellProps {
	tender: Tender;
}

const TENDER_STATUSES = Object.entries(TenderStatus).map(([key, value]) => ({
	key,
	value,
}));

export function TenderStatusCell({ tender }: TenderStatusCellProps) {
	const [selectedTenderStatus, setSelectedTenderStatus] = useState<string>(
		tender.status
	);
	const isDirty = useSelector(selectStatusIsDirty);
	const isLoading = useSelector(selectLoader("tenderStatus"));
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(setStatusIsDiry(false));
		setSelectedTenderStatus(tender.status);
	}, [tender]);

	const onClickApply = useCallback(() => {
		dispatch(updateTenderStatus(tender.id, selectedTenderStatus));
	}, [dispatch, tender, selectedTenderStatus]);

	const onChangeStatus = useCallback(
		(event: SelectChangeEvent<unknown>) => {
			dispatch(setStatusIsDiry(tender.status !== event.target.value));
			setSelectedTenderStatus(event.target.value as string);
		},
		[dispatch, setSelectedTenderStatus, tender]
	);
	return (
		<Box>
			<CustomSelect
				datatestId="test-tender-status-selection"
				name="template"
				label=""
				value={selectedTenderStatus}
				onChange={onChangeStatus}
				sx={{
					borderRadius: "0px",
				}}
				items={TENDER_STATUSES}
			></CustomSelect>
			{isDirty &&
				(isLoading ? (
					<CircularProgress />
				) : (
					<PrimaryButton
						text="Apply"
						type="submit"
						color="primary"
						sx={{
							minWidth: "20px",
						}}
						onClick={onClickApply}
					/>
				))}
		</Box>
	);
}
